import './AddTeacher.scss'

import { CloseCircleFilled } from '@ant-design/icons'
import { Button, Col, Divider, Form, Input, notification, Row, Select, Transfer } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import AppContext from '../../../../../context/AppContext'
import {
  useDerslerQuery,
  useOgretmenEkleMutation,
  useOkulKampusleriQuery,
  useOkulOgretmenDetayQuery,
  useOkulSiniflariOgretmenQuery,
} from '../../../../../gql/GeneratedGraphqlTypes'
import {DEV_BACKEND_DOMAIN} from "../../../../../utils/const";
import Spinner from '../../../../spinner/Spinner'

const { Option } = Select

const AddTeacher: React.FC = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [selectedClasses, setSelectedClasses] = useState<string[]>([])
  const [selectedSubjects, setSelectedSubjects] = useState<string[]>([])
  const { okul,slug, token } = useContext(AppContext)
  const [ogretmenEkleMutation] = useOgretmenEkleMutation()
  const [form] = Form.useForm()
  // **Seçili Kampüs ID (Başlangıçta ilk kampüs atanacak)**
  const [selectedKampusId, setSelectedKampusId] = useState<number>()
  const handleRemoveAllClasses = () => {
    setSelectedClasses([]) // Sağ taraftaki tüm sınıfları kaldırır
  }

  const handleRemoveAllSubjects = () => {
    setSelectedSubjects([]) // Sağ taraftaki tüm dersleri kaldırır
  }
  // Eğer ID varsa öğretmen verisini çek
  const {
    data: ogretmenData,
    loading: ogretmenLoading,
    error: ogretmenError,
  } = useOkulOgretmenDetayQuery({
    variables: {
      ogretmen_id: id ? parseInt(id) : null,
    },
    skip: !id, // ID yoksa sorguyu çalıştırma
    fetchPolicy: 'network-only',
  })

  // **Kampüsleri Çek**
  const {
    data: kampusData,
    loading: kampusLoading,
    error: kampusError,
  } = useOkulKampusleriQuery({
    variables: {
      sube_id: okul?.id,
    },
    fetchPolicy: 'network-only',
  })

  // **İlk yüklemede ilk kampüsü otomatik seç**
  useEffect(() => {
    if (selectedKampusId) {
      form.setFieldsValue({ kampus: selectedKampusId })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKampusId])

  // **Öğretmen detaylarını form ile eşleştirme**
  useEffect(() => {
    if (id && ogretmenData?.okulOgretmenDetay) {
      const ogretmen = ogretmenData.okulOgretmenDetay.ogretmen_bilgileri
      form.setFieldsValue({
        email: ogretmen?.email,
        isim: ogretmen?.isim,
        soyisim: ogretmen?.soyisim,
        gsm: ogretmen?.gsm,
        kampus: parseInt(ogretmen?.kampus!), // Kampüsü forma ekleyelim
      })

      setSelectedKampusId(parseInt(ogretmen?.kampus!)) // Kampüsü state'e ata
      setSelectedClasses(ogretmen?.siniflar ? ogretmen.siniflar.split(', ') : [])
      setSelectedSubjects(ogretmen?.dersler ? ogretmen.dersler.split(', ') : [])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, ogretmenData])

  // **Kampüs seçildiğinde, sınıf listesini güncellemek için sorguyu tetikle**
  const {
    data: sinifData,
    loading: sinifLoading,
    error: sinifError,
  } = useOkulSiniflariOgretmenQuery({
    variables: {
      sube_id: okul?.id,
      arama: null,
      sinif_sube_id: null,
    },
    fetchPolicy: 'network-only',
  })

  const {
    data: dersData,
    loading: dersLoading,
    error: dersError,
  } = useDerslerQuery({
    fetchPolicy: 'network-only',
  })

  // **Loading ve Error Kontrolleri**
  if (kampusLoading || sinifLoading || dersLoading || (id && ogretmenLoading)) {
    return <Spinner showSpinner={true} color="red" />
  }
  if (kampusError || sinifError || dersError || (id && ogretmenError)) {
    console.error(kampusError || sinifError || dersError || ogretmenError)
    navigate('/')
    return null
  }

  // **Sınıf Listesi**
  const classes =
    sinifData?.okulSiniflari?.siniflar?.map((sinif) => ({
      key: sinif?.id.toString(),
      title: sinif?.isim?.toString(),
    })) || []

  const subjects =
    dersData?.dersler?.map((ders) => ({
      key: ders?.id.toString(),
      title: ders?.isim?.toString(),
    })) || []

  const handleSubmit = async (values: any) => {
    const input = {
      isim: values.isim,
      soyisim: values.soyisim,
      email: values.email,
      gsm: values.gsm,
      sifre: values.password || null,
      sifre_onay: values.passwordConfirm || null,
      sinif_ids: selectedClasses.map((id) => parseInt(id)), // String'leri integer yap
      ders_ids: selectedSubjects.map((id) => parseInt(id)), // String'leri integer yap
      kampus: selectedKampusId,
      id: id ? parseInt(id) : undefined,
    }

    try {
      const response = await ogretmenEkleMutation({
        variables: {
          input: {
            ders_ids: input.ders_ids,
            gsm: input.gsm,
            sifre: input.sifre,
            email: input.email,
            isim: input.isim,
            soyisim: input.soyisim,
            kampus: input.kampus,
            sifre_onay: input.sifre_onay,
            sinif_ids: input.sinif_ids,
            id: input.id,
          },
        },
      })
      if (response.data?.ogretmenEkle.success) {
        const { email, isim, okul_slug, dersler, sinifler,sifre } = response.data.ogretmenEkle;

        const url =`https://${slug}.${DEV_BACKEND_DOMAIN}/ogretmen-mail-gonder/${token}/?email=${email}&isim=${isim}&okul_slug=${okul_slug}&dersler=${dersler}&sifre=${sifre}&siniflar=${sinifler}`;
        fetch(url)
            .then((res) => res.json())
            .catch(() => {
              notification.error({
                message: "Mail gönderimi sırasında bir hata oluştu.",
                duration: 6,
              });
            });
        notification.success({
          message: '',
          description: `${response.data?.ogretmenEkle?.message}`,
          duration: 6,
        })
        navigate(-1)
      } else {
        notification.error({
          message: '',
          description: `${response.data?.ogretmenEkle?.message || 'Bir hata oluştu'}.`,
          duration: 6,
        })
      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    }
    // const response = useOgretmenEkleMutation({ variables: { input } });
  }

  return (
    <div className="add-teacher-container">
      <div className="okul-sepeti-admin-header">
        <h1>{id ? 'Öğretmeni Güncelle' : 'Öğretmen Ekle'}</h1>
      </div>
      <Form className="okul-yonetim-detail-form" layout="vertical" onFinish={handleSubmit} form={form}>
        {/* Kullanıcı Bilgileri */}
        <Row className="container-row" gutter={16}>
          <h3> {id ? 'Kayıdı Güncelle' : 'Yeni Kayıt Oluştur '} </h3>
          <Col className="user-info-col" span={24}>
            <Col span={7}>
              <Form.Item label="İsim" name="isim" rules={[{ required: true, message: 'Lütfen isim girin!' }]}>
                <Input disabled={!!id} placeholder="İsim giriniz" />
              </Form.Item>
              <Form.Item label="Soyisim" name="soyisim" rules={[{ required: true, message: 'Lütfen soyisim girin!' }]}>
                <Input disabled={!!id} placeholder="Soyisim giriniz" />
              </Form.Item>
            </Col>
            <Divider type="vertical" />
            <Col span={7}>
              <Form.Item
                  label="GSM"
                  name="gsm"
                  rules={[
                    {
                      required: true,
                      pattern: /^[1-9][0-9]{9}$/, // 10 haneli, başında 0 yok
                      message: 'Geçerli bir telefon numarası giriniz!',
                    },
                  ]}
              >
                <Input
                    maxLength={10} // Kullanıcı 10 karakterden fazlasını yazamaz
                    disabled={!!id}
                    placeholder="Başında 0 olmadan yazınız"
                />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, type: 'email', message: 'Geçerli bir email girin!' }]}
              >
                <Input disabled={!!id} placeholder="Email giriniz" />
              </Form.Item>
            </Col>
            <Divider type="vertical" />
            <Col span={7}>
              <Form.Item
                label="Şifre"
                name="password"
                className="password-input"
                rules={[
                  { required: !id, message: 'Lütfen şifre girin!' }, // Yalnızca yeni ekleme için zorunlu
                ]}
              >
                <Input.Password disabled={!!id} placeholder="Şifre giriniz" />
              </Form.Item>
              <Form.Item
                label="Şifre Onayı"
                name="passwordConfirm"
                dependencies={['password']}
                className="password-input"
                rules={[
                  { required: !id, message: 'Lütfen şifrenizi tekrar giriniz!' }, // Yeni eklemede zorunlu, güncellemede opsiyonel
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value && !id) {
                        return Promise.reject(new Error('Lütfen şifrenizi tekrar giriniz!'))
                      }
                      if (value && getFieldValue('password') !== value) {
                        return Promise.reject(new Error('Şifreler uyuşmuyor!'))
                      }
                      return Promise.resolve()
                    },
                  }),
                ]}
              >
                <Input.Password disabled={!!id} placeholder="Şifrenizi tekrar giriniz" />
              </Form.Item>
            </Col>
          </Col>
          <Col className="user-info-col" span={24}>
            <Col span={7}>
              <Form.Item
                label="Kampüs Seçiniz"
                name="kampus"
                rules={[{ required: true, message: 'Lütfen bir kampüs seçin!' }]}
              >
                <Select
                  placeholder="Kampüs Seçiniz"
                  suffixIcon={false}
                  value={selectedKampusId} // Değeri seçili kampüse bağla
                  onChange={(value) => setSelectedKampusId(value)} // Değiştiğinde güncelle
                >
                  {kampusData?.okulKampusleri?.kampusler?.map((kampus) => (
                    <Option key={kampus?.id} value={kampus?.id}>
                      {kampus?.isim}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Col>

          <Col span={24}>
            <Form.Item label="Mevcut Sınıflar">
              <Transfer
                dataSource={classes}
                titles={[
                  '',
                  <Button className="remove-all" onClick={handleRemoveAllClasses}>
                    Tümünü Kaldır <CloseCircleFilled />
                  </Button>,
                ]}
                targetKeys={selectedClasses}
                onChange={setSelectedClasses}
                showSearch
                filterOption={(input, item) =>
                  input
                    .toLowerCase()
                    .split(' ')
                    .every((word) => item.title?.toLowerCase().includes(word))
                }
                render={(item) => item.title!}
                oneWay
                listStyle={{ width: '100%', height: 355, minWidth: 510 }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Mevcut Dersler">
              <Transfer
                dataSource={subjects}
                titles={[
                  '',
                  <>
                    <Button className="remove-all" onClick={handleRemoveAllSubjects}>
                      Tümünü Kaldır <CloseCircleFilled />
                    </Button>{' '}
                  </>,
                ]}
                targetKeys={selectedSubjects}
                onChange={setSelectedSubjects}
                showSearch={true}
                oneWay
                filterOption={(input, item) =>
                  input
                    .toLowerCase()
                    .split(' ')
                    .every((word) => item.title?.toLowerCase().includes(word))
                }
                render={(item) => item.title!}
                listStyle={{ width: '100%', height: 355, minWidth: 510 }}
              />
            </Form.Item>
          </Col>
          <Button className="back-btn" onClick={() => navigate(-1)} style={{ marginRight: 8 }}>
            Geri
          </Button>
          <Button className="update-btn" htmlType="submit">
            {id ? 'Güncelle' : 'Kaydet'}
          </Button>
        </Row>
      </Form>
    </div>
  )
}

export default AddTeacher
